import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=19e8ed36&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=19e8ed36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e8ed36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19e8ed36')) {
      api.createRecord('19e8ed36', component.options)
    } else {
      api.reload('19e8ed36', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=19e8ed36&scoped=true&", function () {
      api.rerender('19e8ed36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Gc08WG0ACP1A/JS/teamMember.vue"
export default component.exports